import * as React from "react";
import * as style from "./breadcrumbs.module.scss";
import PropTypes from "prop-types";
import Link from "components/Link";

const sizeLimiter = (chain = [], num = chain?.length, ellipsisStr = "...") =>
  chain.length >= num
    ? chain.slice(
        0,
        num >= ellipsisStr.length ? num - ellipsisStr.length : num
      ) + ellipsisStr
    : chain;

const Breadcrumbs = ({ data, narrow, clear }) => {
  let pathContent = "";
  for (const [sectionName, sectionLink] of data.path) {
    pathContent = (
      <>
        {pathContent}
        <div className={style.Breadcrumbs_node}>
          <Link to={sectionLink}>{sectionName}</Link>
        </div>
      </>
    );
  }
  if (pathContent) {
    pathContent = <div className={style.Breadcrumbs_path}>{pathContent}</div>;
  }
  return (
    <div
      className={`
        ${style.Breadcrumbs} ${narrow ? style.Breadcrumbs___narrow : ""} 
        ${style.Breadcrumbs} ${clear ? style.Breadcrumbs___clear : ""} 
      `.trim()}
    >
      {pathContent}
      <div className={style.Breadcrumbs_current}>
        {sizeLimiter(data.current, 100)}
      </div>
    </div>
  );
};

export default Breadcrumbs;

Breadcrumbs.propTypes = {
  data: PropTypes.object,
  narrow: PropTypes.bool,
  clear: PropTypes.bool,
};

Breadcrumbs.displayName = "Breadcrumbs";
